module.exports = __webpack_public_path__ + "img/softwcopr4.81faa7cd.png";